(function ($) {
  "use strict";

  jQuery(document).on('ready', function () {

    $('#ViewMoreOrders').click(function(e) {
      e.preventDefault();
      $('.history-order-table tbody tr:nth-child(n+8)').toggle();
      if ($('#ViewMoreOrders').text() == "View More") {
        $(this).text("View Less")
      } else {
        $(this).text("View More")
      }
  });

    if ($('body').attr('id') == 'press-and-media') {

      document.title = 'Press & Media - House of Lashes®';
    }
    $(' #get-the-look .link-video').hover(function () {
      $(this).toggleClass('remove-right');
    });

    //js the look page\


    $('#get-the-look .custom__item-inner.custom__item-inner--video').click(function () {


      $(this).addClass('hidden-overplay');
      var src = $(this).find('iframe').attr('src');
      $(this).find('iframe').attr('src', src + '?autoplay=1&mute=1&rel=0&showinfo=0&vq=720');



    });

    //js how to apply page\
    $('.hta-header-container .hta-header-row .hta-header-col-right').hover(function () {
      setTimeout(function () {
        $('.hta-header-container .hta-header-row .hta-header-col-right').toggleClass('hidden-overplay-hta-header');
      }, 500);
    });
    $('.apply-think .apply-think-header-row .apply-think-header-col-bottom').hover(function () {
      setTimeout(function () {
        $('.apply-think .apply-think-header-row .apply-think-header-col-bottom').toggleClass('hidden-overplay-think');
      }, 500);
    }); $('.apply-thin .apply-thin-header-row .apply-thin-header-col-bottom').hover(function () {
      setTimeout(function () {
        $('.apply-thin .apply-thin-header-row .apply-thin-header-col-bottom').toggleClass('hidden-overplay-thin');
      }, 500);
    });

    var count_col = 1;
    $('.all-look-container .card-look').each(function () {
      $(this).attr('data-col', `${count_col}`)
      count_col++;
    });


    $('#shopify-section-all-product-need .wrap-all-product').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true,
            infinite: true,
            autoplay: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true,
            infinite: true,
            autoplay: true
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            autoplay: true
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });




    $('.popup-show-video').css({ 'position': 'absolute', 'z-index': '-1', 'bottom': '0', 'left': '-9999px' });

    $('.popup-show-video .cancel').click(function () {
      $(this).closest('.popup-show-video').css('display', 'none');

      $('#get-the-look .custom__item-inner.custom__item-inner--video').removeClass('hidden-overplay');
      $('#pop-up-video .shopify-section').each(function () {
        if ($(this).css('display') === 'block') {
          var src_new = $(this).find('iframe').attr('src');
          var src_old = src_new.replace("?autoplay=0&mute=1&rel=0&showinfo=0&vq=720", "");

          $(this).find('iframe').attr('src', src_old);
        }


      });

    });



    $('.all-look-container .card-look').on('click', function () {
      $('.popup-show-video').css({ 'display': 'block', 'position': 'relative', 'z-index': 'unset', 'bottom': 'unset', 'left': 'unset' });
      $(".popup-show-video .shopify-section").css('display', 'block');

      if ($(this).attr("data-col") == 1 || $(this).attr("data-col") == 2 || $(this).attr("data-col") == 3) {
        $('.popup-show-video').insertAfter($(".all-look-container .card-look[data-col|='3']"));
        //=======================rose-and-ben==================
        if ($(this).attr("data-col") == 1) {
          $(".popup-show-video .shopify-section:not(.rose-and-ben)").css('display', 'none');
        }
        //=======================fall-bridal==================
        if ($(this).attr("data-col") == 2) {
          $(".popup-show-video .shopify-section:not(.fall-bridal)").css('display', 'none');
        }
        //====================how-to-apply-video=====================
        if ($(this).attr("data-col") == 3) {
          $(".popup-show-video .shopify-section:not(.how-to-apply-video)").css('display', 'none');

        }
      }

      if ($(this).attr("data-col") == 4 || $(this).attr("data-col") == 5 || $(this).attr("data-col") == 6) {
        $('.popup-show-video').insertAfter($(".all-look-container .card-look[data-col|='6']"));
        //====================lash-and-go=====================
        if ($(this).attr("data-col") == 4) {
          $(".popup-show-video .shopify-section:not(.lash-and-go)").css('display', 'none');
        }
        //====================lash-stash=====================
        if ($(this).attr("data-col") == 5) {
          $(".popup-show-video .shopify-section:not(.lash-stash)").css('display', 'none');
        }
        //====================iconic-luxe-launch=====================
        if ($(this).attr("data-col") == 6) {
          $(".popup-show-video .shopify-section:not(.iconic-luxe-launch)").css('display', 'none');
        }
      }

      if ($(this).attr("data-col") == 7 || $(this).attr("data-col") == 8 ) {
        $('.popup-show-video').insertAfter($(".all-look-container .card-look[data-col|='8']"));
      
        //====================target-campaign=====================
        if ($(this).attr("data-col") == 7) {
          $(".popup-show-video .shopify-section:not(.target-campaign)").css('display', 'none');
        }
        //====================how-to-clean=====================
        if ($(this).attr("data-col") == 8) {
          $(".popup-show-video .shopify-section:not(.how-to-clean)").css('display', 'none');
        }
      }

      if (window.innerWidth <= 767) {

        $('html, body').animate({
          scrollTop: $(this).find('.link-video').offset().top - 200
        }, 500);

      } else {

        $('html, body').animate({
          scrollTop: $('#pop-up-video').offset().top - 190
        }, 500);

      }
      $('#get-the-look .custom__item-inner.custom__item-inner--video').removeClass('hidden-overplay');
    });

    //end

    //tab table translate X
    var width_first = $('#shipping-policy .row-first .col-th:first-child').outerWidth();
    var width_table_child = $('#shipping-policy .wrap-table-child').outerWidth();
    var width_last = parseInt(width_table_child) - parseInt(width_first);

    $('#shopify-section-shipping-mainland-table .item-tab').on('click', function () {
      $(this).addClass("active");
      if ($(this).is(":nth-child(2)")) {
        var name_element = $(this).closest('.shopify-section').find('.wrap-table-child');
        name_element.css("transform", `translateX(${-width_first}px)`);
      }
      if ($(this).is(":first-child")) {
        var name_element = $(this).closest('.shopify-section').find('.wrap-table-child');
        name_element.css("transform", "translateX(0px)");
      }
      if ($(this).is(":nth-child(3)")) {
        var name_element = $(this).closest('.shopify-section').find('.wrap-table-child');
        name_element.css("transform", `translateX(${-width_last}px)`);
      }

      $('#shopify-section-shipping-mainland-table .item-tab').not(this).removeClass("active");
      $("#shipping-policy .tab-container").css('-webkit-animation', 'none');

    });



    $('#shopify-section-shipping-territories-table .item-tab').on('click', function () {
      $(this).addClass("active");
      if ($(this).is(":nth-child(2)")) {
        var name_element = $(this).closest('.shopify-section').find('.wrap-table-child');
        name_element.css("transform", `translateX(${-width_first}px)`);
      }
      if ($(this).is(":first-child")) {
        var name_element = $(this).closest('.shopify-section').find('.wrap-table-child');
        name_element.css("transform", "translateX(0px)");
      }
      if ($(this).is(":nth-child(3)")) {
        var name_element = $(this).closest('.shopify-section').find('.wrap-table-child');
        name_element.css("transform", `translateX(${-width_last}px)`);
      }
      $('#shopify-section-shipping-territories-table .item-tab').not(this).removeClass("active");
      $("#shipping-policy .tab-container").css('-webkit-animation', 'none');
    });


    $('#shopify-section-shipping-international-table .item-tab').on('click', function () {
      $(this).addClass("active");
      if ($(this).is(":nth-child(2)")) {
        var name_element = $(this).closest('.shopify-section').find('.wrap-table-child');
        name_element.css("transform", `translateX(${-width_first}px)`);
      }
      if ($(this).is(":first-child")) {
        var name_element = $(this).closest('.shopify-section').find('.wrap-table-child');
        name_element.css("transform", "translateX(0px)");
      }
      if ($(this).is(":nth-child(3)")) {
        var name_element = $(this).closest('.shopify-section').find('.wrap-table-child');
        name_element.css("transform", `translateX(${-width_last}px)`);
      }
      $('#shopify-section-shipping-international-table .item-tab').not(this).removeClass("active");
      $("#shipping-policy .tab-container").css('-webkit-animation', 'none');
    });


    //accordion

    if (window.innerWidth <= 767) {
      // get the look on mobile


      $('.all-look-container .card-look').on('click', function () {
        $('.popup-show-video').insertAfter($(this));
        $('.popup-show-video').css({ 'display': 'block', 'position': 'relative', 'z-index': 'unset', 'bottom': 'unset', 'left': 'unset' });
        $(".popup-show-video .shopify-section").css('display', 'block');

        //=======================rose-and-ben==================        
        if ($(this).attr("data-col") == 1) {

          $(".popup-show-video .shopify-section:not(.rose-and-ben)").css('display', 'none');
        }
        if ($(this).attr("data-col") == 2) {

          $(".popup-show-video .shopify-section:not(.patrick-ta-master)").css('display', 'none');
        }
        if ($(this).attr("data-col") == 3) {

          $(".popup-show-video .shopify-section:not(.fall-bridal)").css('display', 'none');
        }
        if ($(this).attr("data-col") == 4) {

          $(".popup-show-video .shopify-section:not(.how-to-apply-video)").css('display', 'none');

        }
        if ($(this).attr("data-col") == 5) {
          $(".popup-show-video .shopify-section:not(.lash-and-go)").css('display', 'none');
        }
        if ($(this).attr("data-col") == 6) {

          $(".popup-show-video .shopify-section:not(.lash-stash)").css('display', 'none');
        }
        if ($(this).attr("data-col") == 7) {

          $(".popup-show-video .shopify-section:not(.iconic-luxe-launch)").css('display', 'none');
        }
        if ($(this).attr("data-col") == 8) {

          $(".popup-show-video .shopify-section:not(.target-campaign)").css('display', 'none');
        }

        //====================hol-mask=====================
        if ($(this).attr("data-col") == 9) {

          $(".popup-show-video .shopify-section:not(.hol-mask)").css('display', 'none');
        }



        if ($(this).attr("data-col") == 10) {

          $(".popup-show-video .shopify-section:not(.pride-message)").css('display', 'none');

        }
        if ($(this).attr("data-col") == 11) {

          $(".popup-show-video .shopify-section:not(.how-to-clean)").css('display', 'none');

        }



      });



      $("#faq .link_container .shopify-section .page__accordions").slideUp(100);
      $("#faq .link_container .shopify-section:nth-child(2) .page__accordions").slideDown(100);
      $("#faq .link_container .shopify-section:nth-child(2) .faq__title").addClass("faq-minus active");

      $("#faq .link_container .shopify-section .faq__title").on("click", function () {
        if ($(this).hasClass("active")) {
          $(this).removeClass("active");
          $(this)
            .siblings(".page__accordions")
            .slideUp(200);
          $("#faq .link_container .shopify-section .faq__title")
            .removeClass("faq-minus")
            .addClass("faq-plus");
        } else {
          $("#faq .link_container .shopify-section .faq__title")
            .removeClass("faq-minus")
            .addClass("faq-plus");
          $(this)
            .removeClass("faq-plus")
            .addClass("faq-minus");
          $(this).removeClass("active");
          $(this).addClass("active");
          $(".page__accordions").slideUp(200);
          $(this)
            .siblings(".page__accordions")
            .slideDown(200);
        }
      });


      $("#return-policy .content-accordion").slideUp(100);
      $("#shopify-section-returns-for-international .content-accordion").slideDown(100);
      $("#shopify-section-returns-for-international .title-accordion").addClass("faq-minus active");
      $("#return-policy .title-accordion").on("click", function () {
        if ($(this).hasClass("active")) {
          $(this).removeClass("active");
          $(this)
            .siblings(".content-accordion")
            .slideUp(200);
          $("#return-policy .title-accordion")
            .removeClass("faq-minus")
            .addClass("faq-plus");
        } else {
          $("#return-policy .title-accordion")
            .removeClass("faq-minus")
            .addClass("faq-plus");
          $(this)
            .removeClass("faq-plus")
            .addClass("faq-minus");
          $(this).removeClass("active");
          $(this).addClass("active");
          $(".content-accordion").slideUp(200);
          $(this)
            .siblings(".content-accordion")
            .slideDown(200);
        }
      });



      $("#shopify-section-shipping-content-below .content-detailt").slideUp(100);
      $("#shopify-section-shipping-content-below .wrap-content:first-child .content-detailt").slideDown(100);
      $("#shopify-section-shipping-content-below .wrap-content:first-child .title-content").addClass("faq-minus active");

      $("#shopify-section-shipping-content-below .title-content").on("click", function () {
        if ($(this).hasClass("active")) {
          $(this).removeClass("active");
          $(this)
            .siblings(".content-detailt")
            .slideUp(200);
          $("#shopify-section-shipping-content-below .title-content")
            .removeClass("faq-minus")
            .addClass("faq-plus");
        } else {
          $("#shopify-section-shipping-content-below .title-content")
            .removeClass("faq-minus")
            .addClass("faq-plus");
          $(this)
            .removeClass("faq-plus")
            .addClass("faq-minus");
          $(this).removeClass("active");
          $(this).addClass("active");
          $(".content-detailt").slideUp(200);
          $(this)
            .siblings(".content-detailt")
            .slideDown(200);
        }

      });

      $('#lash-care .wrap-all-product').slick({
        dots: true,
        infinite: true,
        speed: 500,
        fade: true,
        autoplay: true,
        cssEase: 'linear'
      });




    }




    //accordion end

    $('#shopify-section-faq-link-scroll .card_link:nth-child(1)').attr('href', '#shopify-section-faq-shipping');
    $('#shopify-section-faq-link-scroll .card_link:nth-child(2)').attr('href', '#shopify-section-faq-student-discount');
    $('#shopify-section-faq-link-scroll .card_link:nth-child(3)').attr('href', '#shopify-section-faq-about');
    $('#shopify-section-faq-link-scroll .card_link:nth-child(4)').attr('href', '#shopify-section-faq-product-information');
    $('#shopify-section-faq-link-scroll .card_link:nth-child(5)').attr('href', '#shopify-section-faq-pr');
    // anchor link

    $("a.scrollLink").click(function (event) {
      event.preventDefault();
      $("html, body").animate({ scrollTop: $($(this).attr("href")).offset().top - 210 }, 500);
    });

  });

})(jQuery);


// how to apply products//
if (window.innerWidth <= 415) {
  $('#shopify-section-hta-page-products .wrap-all-product').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          infinite: true,
          autoplay: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
          infinite: true,
          autoplay: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          autoplay: true
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
}

$(function() {
    $(".carousel--image-details").each(function(index, element){
        var $this = $(this);
    
        // Generate unique class for each feature collection slider
        $this.addClass("image-details-instance-" + index);
        $this.parents('.image-details').find(".image-details-swiper-pagination").addClass("image-details-swiper-pagination-" + index);
    
        // Initialize feature collection slider based on the unique classes generated above.
        var swiper = new Swiper(".image-details-instance-" + index, {
            // Optional parameters
            slidesPerView: 1,
            spaceBetween: 15,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
            autoHeight: true,
            pagination: {
                el: ".image-details-swiper-pagination-" + index,
                type: 'bullets',
                clickable: true,
            },
            breakpoints: {
              // when window width is >= 680px
              1024: {
                slidesPerView: 8,
                autoHeight: false
              }
            }
        });
    
        swiper.slides.forEach(function(slide, index) {
            slide.addEventListener('focus', function(e) {
                swiper.slideTo(index);
            })
        });
    });
});


$(function() {
  const CAROUSEL_SELECTOR = '.carousel--featured-collection';
  const CAROUSEL_CLASS = 'carousel--featured-collection';
  const CAROUSEL_SECTION_SELECTOR = '.featured-product-slider__container';
  const CAROUSEL_SECTION_CLASS = 'featured-product-slider__container';
  const CAROUSEL_PREV_BUTTON_SELECTOR = '.swiper-button-prev';
  const CAROUSEL_NEXT_BUTTON_SELECTOR = '.swiper-button-next';

  // // Pre-calculate slider heights before initialization to prevent layout shift
  // document.querySelectorAll(CAROUSEL_SECTION_SELECTOR).forEach((element) => {
  //   const slider = element.querySelector(CAROUSEL_SELECTOR);
  //   if (slider) {
  //     // Ensure the slider has the correct height before initialization
  //     const slides = slider.querySelectorAll('.swiper-slide');
  //     if (slides.length > 0) {
  //       // Get the tallest slide height if possible
  //       let maxHeight = 0;
  //       slides.forEach(slide => {
  //         const productCard = slide.querySelector('.product-card');
  //         if (productCard) {
  //           const height = productCard.offsetHeight;
  //           maxHeight = Math.max(maxHeight, height);
  //         }
  //       });
        
  //       // If we found a height, apply it
  //       if (maxHeight > 0) {
  //         slider.style.minHeight = `${maxHeight + 40}px`; // Add some padding
  //       }
  //     }
  //   }
  // });

  document.querySelectorAll(CAROUSEL_SECTION_SELECTOR)
      .forEach((element, index) => {
          // Generate unique class for each collection list slider
          element.querySelector(CAROUSEL_SELECTOR).classList.add(`${CAROUSEL_CLASS}-${index}`);

          // Generate unique btn classes for slider arrows
          element.querySelector(CAROUSEL_PREV_BUTTON_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-btn-prev-${index}`);
          element.querySelector(CAROUSEL_NEXT_BUTTON_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-btn-next-${index}`);

          const swiper = new Swiper(`.${CAROUSEL_CLASS}-${index}`, {
              // Optional parameters
              slidesPerView: 2,
              spaceBetween: 15,
              observer: true,
              observeParents: true,
              a11y: false,
              watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
              preloadImages: true,
              watchSlidesProgress: true,

              breakpoints: {
                  // when window width is >= 680px
                  680: {
                      slidesPerView: 4,
                      spaceBetween: 30
                  }
              },

              navigation: {
                  nextEl: `.${CAROUSEL_SECTION_CLASS}-btn-next-${index}`,
                  prevEl: `.${CAROUSEL_SECTION_CLASS}-btn-prev-${index}`
              },
              
              // Handle initialization events to prevent layout shift
              on: {
                init: function() {
                  // Remove the not-initialized class and show the slider
                  const swiperEl = document.querySelector(`.${CAROUSEL_CLASS}-${index}`);
                  if (swiperEl) {
                    swiperEl.classList.remove('swiper-not-initialized');
                    // Fade in the slider
                    setTimeout(() => {
                      swiperEl.style.opacity = '1';
                    }, 50);
                  }
                },
                imagesReady: function() {
                  // Update swiper dimensions when images are loaded
                  this.update();
                }
              }
          });
          
          // Force update after a short delay to ensure proper layout
          setTimeout(() => {
            swiper.update();
          }, 100);
      });
});


$(function() {
  const CAROUSEL_SELECTOR = '.carousel--featured-collection';
  const CAROUSEL_CLASS = 'carousel--featured-collection';
  const CAROUSEL_SECTION_SELECTOR = '.featured-collection__container';
  const CAROUSEL_SECTION_CLASS = 'featured-collection__container';
  const CAROUSEL_PREV_BUTTON_SELECTOR = '.swiper-button-prev';
  const CAROUSEL_NEXT_BUTTON_SELECTOR = '.swiper-button-next';

  document.querySelectorAll(CAROUSEL_SECTION_SELECTOR)
      .forEach((element, index) => {
          // Quick exit if no carousel found in carousel section
          if (!element.querySelector(CAROUSEL_SELECTOR)) return;
          
          // Generate unique class for each collection list slider
          element.querySelector(CAROUSEL_SELECTOR)?.classList.add(`${CAROUSEL_CLASS}-${index}`);

          // Generate unique btn classes for slider arrows
          element.querySelector(CAROUSEL_PREV_BUTTON_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-btn-prev-${index}`);
          element.querySelector(CAROUSEL_NEXT_BUTTON_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-btn-next-${index}`);

          const swiper = new Swiper(`.${CAROUSEL_CLASS}-${index}`, {
              // Optional parameters
              slidesPerView: 2,
              spaceBetween: 15,
              observer: true,
              observeParents: true,
              a11y: false,
              watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.

              breakpoints: {
                  // when window width is >= 680px
                  680: {
                      slidesPerView: 4,
                      spaceBetween: 30
                  }
              },

              navigation: {
                  nextEl: `.${CAROUSEL_SECTION_CLASS}-btn-next-${index}`,
                  prevEl: `.${CAROUSEL_SECTION_CLASS}-btn-prev-${index}`
              }
          });

          swiper.slides.forEach(function(slide, index) {
              const slideLink = slide.querySelector('a');
              slideLink.addEventListener('focus', function() {
                  swiper.slideTo(index);
              });
          });
      });
});

    

$(function() {
  const CAROUSEL_SELECTOR = '.carousel--image-slider'; // Swiper Carousel class
  const CAROUSEL_CLASS = 'carousel--image-slider';
  const CAROUSEL_SECTION_SELECTOR = '.image-slider-section'; // Container class
  const CAROUSEL_SECTION_CLASS = 'image-slider-section';
  const CAROUSEL_PREV_BUTTON_SELECTOR = '.swiper-button-prev';
  const CAROUSEL_NEXT_BUTTON_SELECTOR = '.swiper-button-next';
  const CAROUSEL_PAGINATION_SELECTOR = '.swiper-pagination';

  document.querySelectorAll(CAROUSEL_SECTION_SELECTOR)
      .forEach((element, index) => {
          // Generate unique class for each collection list slider
          element.querySelector(CAROUSEL_SELECTOR).classList.add(`${CAROUSEL_CLASS}-${index}`);

          // Generate unique btn classes for slider arrows
          element.querySelector(CAROUSEL_PREV_BUTTON_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-btn-prev-${index}`);
          element.querySelector(CAROUSEL_NEXT_BUTTON_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-btn-next-${index}`);

          // Generate unique btn classes for swiper pagination
          element.querySelector(CAROUSEL_PAGINATION_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-pagination-${index}`);

          const swiper = new Swiper(`.${CAROUSEL_CLASS}-${index}`, {
              // Optional parameters
              slidesPerView: 2,
              spaceBetween: 15,
              observer: true,
              observeParents: true,
              a11y: false,
              watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.

              breakpoints: {
                  // when window width is >= 680px
                  768: {
                      slidesPerView: 4,
                      spaceBetween: 30
                  }
              },
              navigation: {
                  nextEl: `.${CAROUSEL_SECTION_CLASS}-btn-next-${index}`,
                  prevEl: `.${CAROUSEL_SECTION_CLASS}-btn-prev-${index}`
              },
              pagination: {
                  el: `.${CAROUSEL_SECTION_CLASS}-pagination-${index}`,
                  type: 'bullets',
                  clickable: true,
              },
          });
          

          swiper.slides.forEach(function(slide, index) {
              const slideLink = slide.querySelector('a');
              slideLink.addEventListener('focus', function() {
                  swiper.slideTo(index);
              });
          });
      });
      
      // Notes
      // If mutation observer errors show up, make sure you've targeted the right classes for carousel selector and carousel section selector.
      // 
});

$(function() {
  const CAROUSEL_SELECTOR = '.carousel--image-slider'; // Swiper Carousel class
  const CAROUSEL_CLASS = 'carousel--image-slider';
  const CAROUSEL_SECTION_SELECTOR = '.page-section--image-slider'; // Container class
  const CAROUSEL_SECTION_CLASS = 'page-section--image-slider';
  const CAROUSEL_PREV_BUTTON_SELECTOR = '.swiper-button-prev';
  const CAROUSEL_NEXT_BUTTON_SELECTOR = '.swiper-button-next';
  const CAROUSEL_PAGINATION_SELECTOR = '.swiper-pagination';

  document.querySelectorAll(CAROUSEL_SECTION_SELECTOR)
      .forEach((element, index) => {
          // Generate unique class for each collection list slider
          element.querySelector(CAROUSEL_SELECTOR).classList.add(`${CAROUSEL_CLASS}-${index}`);

          // Generate unique btn classes for slider arrows
          element.querySelector(CAROUSEL_PREV_BUTTON_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-btn-prev-${index}`);
          element.querySelector(CAROUSEL_NEXT_BUTTON_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-btn-next-${index}`);

          // Generate unique btn classes for swiper pagination
          element.querySelector(CAROUSEL_PAGINATION_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-pagination-${index}`);

          const swiper = new Swiper(`.${CAROUSEL_CLASS}-${index}`, {
              // Optional parameters
              slidesPerView: 1.2,
              spaceBetween: 10,
              observer: true,
              observeParents: true,
              a11y: false,
              watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.

              breakpoints: {
                  // when window width is >= 680px
                  768: {
                      slidesPerView: 3
                  }
              },
              navigation: {
                  nextEl: `.${CAROUSEL_SECTION_CLASS}-btn-next-${index}`,
                  prevEl: `.${CAROUSEL_SECTION_CLASS}-btn-prev-${index}`
              },
              pagination: {
                  el: `.${CAROUSEL_SECTION_CLASS}-pagination-${index}`,
                  type: 'bullets',
                  clickable: true,
              },
          });
          

          swiper.slides.forEach(function(slide, index) {
              const slideLink = slide.querySelector('a');
              slideLink.addEventListener('focus', function() {
                  swiper.slideTo(index);
              });
          });
      });
      
      // Notes
      // If mutation observer errors show up, make sure you've targeted the right classes for carousel selector and carousel section selector.
      // 
});

// START - 2024 Desktop Navidation
$(function() {
  $('.desktop-nav_level1-item').on('mouseenter', function() {
    var $firstSubmenuTab = $(this).find('.desktop-nav_dropdown-tab[data-index="0"]');
    var $firstSubmenu = $(this).find('.desktop-nav_dropdown-tabcontent[data-index="0"]');
    if ($firstSubmenu.length) {
      $('.desktop-nav_dropdown-tab').removeClass('is-hover');
      $('.desktop-nav_dropdown-tabcontent').removeClass('is-visible');
      $firstSubmenuTab.addClass('is-hover');
      $firstSubmenu.addClass('is-visible');
    }
  });

  $('.desktop-nav_dropdown-tab').on('mouseenter', function() {
    var $this = $(this);
    var $dropdown = $this.parents('.desktop-nav_level2-wrapper');
    var thisIndex = $this.data('index');
    var $tabContents = $dropdown.find('.desktop-nav_dropdown-tabcontent[data-index="' + thisIndex + '"]')

    $('.desktop-nav_dropdown-tab').removeClass('is-hover');
    $this.addClass('is-hover');
    
    $('.desktop-nav_dropdown-tabcontent').removeClass('is-visible');
    $tabContents.addClass('is-visible');

  });
});
// END - 2024 Desktop Navidation

function filterUpdate() {
  var headerHeight = $('#shopify-section-header').outerHeight();
  var collectionTop = $('#Collection').offset().top;
  var targetScroll = collectionTop - headerHeight;
  if ($(document).scrollTop() > targetScroll) {
    $("html, body").animate({ scrollTop: targetScroll + 'px' });
  }
}


$(window).on("load", function () {
    AOS.init({once: true});
});